import store from '../../init/store.js'
import {getUpdatedCombatantStateFromDescriptionMerge} from './get-combatants-state-change'
import {addQueuedSubmissions} from '../cloud-queue.js'
import {getColoredNameById} from '../../helpers/rollout-message-text-helpers.js'
import {isBattleOver} from './get-dead-teams'
import {getDescriptionObjectFromSubmission} from './get-description-object'
import BattleActions from '../battle-data/battle-actions.js'


/** Return array of step models */
export function getRollout(actionModel, casterModel, targetModels, descriptionObject) { //I want to reword this to `submittedActionModel`, because the output may have more than 1 action depending on PRE/POST/NATURAL adds.

  //Get Submission result messages
  let messageSteps = [];
  if (descriptionObject.didFail) {
    messageSteps = actionModel.getFailStep(actionModel, casterModel, targetModels, descriptionObject);
  }
  if (descriptionObject.didMiss) {
    messageSteps = actionModel.getMissStep(actionModel, casterModel, targetModels, descriptionObject);
  }
  if (descriptionObject.wasBugged) {
    messageSteps = actionModel.getBuggedStep(actionModel, casterModel, targetModels, descriptionObject);
  }

  if (!descriptionObject.didFail && !descriptionObject.didMiss && !descriptionObject.wasBugged) {
    messageSteps = actionModel.getSuccessStep(actionModel, casterModel, targetModels, descriptionObject);
  }

  //Prepend the lagging message. (NOTE: at this point, the attack is already successful. We just want to add the messaging)
  //TODO: this particular part could be extracted to it's own function, but I think it's okay right here
  if (casterModel.status === "lag" && !actionModel.isItem && !actionModel.isNatural) {
    // console.log(actionModel)
    messageSteps = [
      {
        type: "message",
        content: [
          getColoredNameById(casterModel.id),
          `'s connection is laggy...`,
        ]
      },
      ...messageSteps
    ]
  }
  ///

  //Steps from main action.
  const stepsFromSubmittedAction = [
    ...messageSteps,
    {
      type: "stateChange",
      newCombatantState: descriptionObject.state,
      description: descriptionObject.description || {}
    }
  ];


  //Now lets get the "post" steps.....
  //Figure out what the state is after the main attack's description object
  let combatants = getUpdatedCombatantStateFromDescriptionMerge(store.getState().battle.combatants, descriptionObject.state);

  const casterModelId = casterModel.id;
  const targetIds = targetModels.map(targetModel => targetModel.id);


  //Get next possible Post steps by using newCombatantState from previous possible post thing (TODO: can we make this code prettier?)
  //We have to do this: `combatants[casterModelId]` to make sure we're passing the most up to date casterModel.

  //Check if target(s) died from my Submitted Action
  const targetDieResultModel = getDieResultModel(targetIds.map(targetId => combatants[targetId]), combatants, actionModel);

  //Get results from Steal-And-Use if relevant
  const stealAndUseResultModel = getStealAndUseResultModel(combatants[casterModelId], combatants, descriptionObject);

  //Update combatants with output of getStealAndUseResultModel
  combatants = getUpdatedCombatantStateFromDescriptionMerge(combatants, stealAndUseResultModel.newCombatantState);

  //Get memory leak steps by using the simulated version of `combatants` after the first action has been applied.
  const memLeakResultModel = getMemoryLeakSteps(combatants[casterModelId], combatants);

  //Update combatants with output of memLeakSteps
  combatants = getUpdatedCombatantStateFromDescriptionMerge(combatants, memLeakResultModel.newCombatantState);

  //Check if the caster died from post things
  const casterDieResultModel = (actionModel.ignoreCasterDieResult) //Actions (like promise_resolve) may choose to ignore announcing the caster is dead
    ? { steps: [], newCombatantState: {...combatants}} //If we're opting out of this message, just supply a vanilla step in the chain with no modifications
    : getDieResultModel([combatants[casterModelId]], combatants, actionModel); //Otherwise, pipe through the death catcher



  /** Provide updated cloudQueue at the end of the rollout with future queued actions */
  let cloudQueuePayload = [...store.getState().battle.cloudQueue]; //Start with initial cloudQueueue

  //For each followup, generate the new queue
  (descriptionObject.description.followupActions || []).forEach(followupAction => {
    const action = {
      sortBeforeCombatant: followupAction.casterId,
      actionId: followupAction.id,
      casterId: followupAction.casterId,
      target: followupAction.targetIds
    };
    cloudQueuePayload = [...addQueuedSubmissions(cloudQueuePayload, action, followupAction.turnsToWait)]
  });


  const cloudQueueStep = {
    type: "cloudQueue",
    payload: [...cloudQueuePayload]
  };

  return [
    //The steps from my form-submitted intended action
    ...stepsFromSubmittedAction,

    //Steal and Use item action
    ...stealAndUseResultModel.steps,

    //This does not cause duplicate "dies" for memory leaks because we are only checking the Target deaths of the SUBMITTED action. Not the post ones.
    ...targetDieResultModel.steps,

    //Memory leak / Fire stuff
    ...memLeakResultModel.steps,

    //I died from memory leak or fire
    ...casterDieResultModel.steps, //only checks if the caster was defeated

    //Include latest cloudQueue, because I may have added future actions.
    cloudQueueStep
  ];

}



/* If this steal-and-use key exists, get result model */
function getStealAndUseResultModel(casterModel, combatants, currentDescObj = {}) {

  if (currentDescObj && currentDescObj.description.stealAndUseItems) {

    const itemAction = currentDescObj.description.stealAndUseItems[0]; //Limiting this to 1 steal and use.
    //If stealing/using more than 1 item is a thing in the future, feel free to revisit this :) Just need to return more steps

    //Copied from Natural helper below. Didn't think it was safe to couple them yet in case something has to change
    const actionModel = {
      id: itemAction.actionId,
      ...BattleActions[itemAction.actionId],
      actionMeta: {...itemAction} //need instanceId to use an item
    };


    //Get a description object for this guy
    const descriptionObject = getDescriptionObjectFromSubmission(
      actionModel, casterModel, [casterModel], combatants
    );

    //Create success step
    const successStep = actionModel.getSuccessStep(actionModel, casterModel, [casterModel], descriptionObject);

    //Create fail step
    const failStep = actionModel.getFailStep(actionModel, casterModel, [casterModel], descriptionObject);

    //Determine which steps to use
    const useSteps = descriptionObject.didFail
      ? failStep
      : successStep;


    return {
      steps: [
        ...useSteps,

        //animation step?
        {
          type: "stateChange",
          newCombatantState: descriptionObject.state,
          description: descriptionObject.description || {}
        }
      ],
      newCombatantState: descriptionObject.state
    }

  }

  //If not a steal-and-use thing, just default to this:
  return {
    steps: [],
    newCombatantState: combatants
  }
}

function getMemoryLeakSteps(casterModel, combatants) {

  //Stop here if the battle is over... no extra rollout steps to be added
  if (isBattleOver(combatants)) {
    return {
      steps: [],
      newCombatantState: combatants
    }
  }

  //If Caster has memory leak or fire, tack on the extra rollout steps
  if (casterModel.status === "memory-leak") {
    return getNaturalActionResultModel("natural_hurt-by-memory-leak", casterModel, combatants)
  }

  if (casterModel.status === "fire") {
    return getNaturalActionResultModel("natural_hurt-by-fire", casterModel, combatants)
  }

  //Caster is not memory-leaking
  //Default: return 0 steps and the same state as before
  return {
    steps: [],
    newCombatantState: combatants
  }
}

/**
 "Result Model"
 {
   steps: [], //StepModels
   newCombatantState: [], //new properties in combatants (not always full combatant models)
 }
 */

function getDieResultModel(combatantModels = [], combatants, actionModel) {

  let steps = [];
  let newCombatantState = {...combatants};

  combatantModels.filter(model => {

    //If this action ignores death message, just return false.
    if (actionModel.ignoreTargetDieResult) {
      return false
    }

    return !model.isAlive(); //Only return TRUE for combatants who are dead
  }).forEach(model => {

    const natural = getNaturalActionResultModel("natural_die", model, combatants);
    steps = [
      ...steps,
      ...natural.steps
    ];
    newCombatantState = getUpdatedCombatantStateFromDescriptionMerge(newCombatantState, natural.newCombatantState)
  });

  return {
    steps: steps,
    newCombatantState: newCombatantState
  }
}


/** Get the RolloutSteps for any natural action. (builds in the actionId/Caster/Target stuff) */
//`getNaturalActionResultModel`
function getNaturalActionResultModel(actionId = "", casterModel, combatants) {

  const actionModel = BattleActions[actionId];

  //Get a description object for this guy
  const descriptionObject = getDescriptionObjectFromSubmission(
    actionModel, casterModel, [casterModel], combatants
  );

  //Create success step
  const successStep = actionModel.getSuccessStep(actionModel, casterModel, [casterModel], descriptionObject);


  //Can this pattern be part of the action model? Like a function that gets the arrangement of the array?
  //That way some actions could customize it?

  return {
    steps: [
      ...successStep,
      //Might need an animation step {} here
      {
        type: "stateChange",
        newCombatantState: descriptionObject.state,
        description: descriptionObject.description || {}
      }
    ],
    newCombatantState: descriptionObject.state
  }

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-rollout.js